import React from 'react';
import { Box, Typography } from '@material-ui/core';

import useStyles from "./IntroStep.style";

import logo from "../../../images/logo_color.png";

const IntroStep = props => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Box className={classes.logoContainer}>
                <img src={logo} alt="logo" />
            </Box>
            <Box className={classes.textContainer}>
                <Typography variant="h5" className={classes.text}>
                    {props.text}
                </Typography>
            </Box>
            {props.children}
        </Box>
    );
};

export default IntroStep;